module.exports = __webpack_public_path__ + "img/download.197394e7.png";